/**
 * 寻源失败文案(UI 层)。
 *
 * 服务端已经把上游报错翻成业务话术(crm-engine/services/sourcing-error.ts),这里只做两件事:
 *   1) 兜底:万一有原始报错漏过来(老缓存/老页面),不把供应商品牌、错误码、QQ/微信、链接显给业务员;
 *   2) 统一前缀,列表弹窗和详情页说同一句话。
 */

/** 像上游原文:带英文错误码 / 链接 / 联系方式 / 数据源品牌 */
const RAW_UPSTREAM_RE = /onebound|error\s+[a-z0-9_]+:|https?:\/\/|QQ[:：]|微信|\bkey\b/i;

const FALLBACK = '找货源失败，请重试。一直失败请联系管理员。';

/** 拿到一句能直接显给业务员的失败原因(不带图标)。 */
export function sourcingErrorText(msg: string | null | undefined): string {
  const t = (msg ?? '').trim();
  if (!t || RAW_UPSTREAM_RE.test(t)) return FALLBACK;
  return t.length > 140 ? `${t.slice(0, 140)}…` : t;
}
